import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import { AUTHORIZATION_CODE_QUERY_PARAM } from '@wix/thunderbolt-symbols'
import type { MpaNavigationSiteConfig } from '../types'

const mpaNavigationSiteConfig: SiteConfigFn<MpaNavigationSiteConfig> = ({ api, funcLib }) => {
	const forceMpaNavigation = api.env.getExperiments()['specs.thunderbolt.forceMpaNavigation'] === true

	const requestUrl = api.originalRequest.getUrl()
	const isRunningInDifferentSiteContext = !!funcLib.getQueryParamValue(requestUrl, AUTHORIZATION_CODE_QUERY_PARAM)
	const hasFeedbackQueryParam = funcLib.getQueryParamValue(requestUrl, 'rc') === 'feedback'

	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
		siteConfig: {
			forceMpaNavigation,
			isRunningInDifferentSiteContext,
			hasFeedbackQueryParam,
		},
	}
}

const name = 'mpaNavigation'

export const config = { site: mpaNavigationSiteConfig, name }
